/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
import React, {useEffect, useState, useReducer} from 'react';
import {Spinner} from 'reactstrap';
import {useLocation} from 'react-router-dom';
import EditableGrid from './EditableGridDash';
import PaginationFooter from './PaginationFooter';
import {DataGridContainer, AccumulatorCel, AccumulatorRow} from './styled';
import {generateRowRule, generateHeader} from '../../utils/utils';
import {useInitialRenderEffect} from '../../utils/functions';
import Alert from '../Notification';
import Accumulators from './Accumulators';
import dataGridReducer from './dataGridReducer';
import {DATAGRID} from '../../utils/constants';
import DataGridContext from './DataGridContext';
import {setCurrentCel} from './dataGridActions';

const DashDataGrid = ({
  header,
  data,
  groupBy,
  keyProp,
  keyValueProp,
  titleProp,
  fixedColumn,
  width,
  fixedAccumulator = false,
  editableCelOnly = false,
  accumulators = null,
  disabledPaginate,
}) => {
  const [state, dispatch] = useReducer(dataGridReducer, {
    mode: DATAGRID.TABLE.MODE.READ,
    currentLine: null,
    initialData: data,
    actionQueue: [],
    fixedAccumulator,
    errors: {},
  });

  const location = useLocation();
  const perPageStorage = () => {
    const perPageSession = JSON.parse(window.localStorage.getItem('perPageStorage')) || {};
    if (perPageSession[location.pathname]) {
      return perPageSession[location.pathname];
    }
    return 50;
  };

  const [alertProps] = useState(null);
  const [itemsPerpage, setItemsPerpage] = useState(perPageStorage());
  const [currentPage, setCurrentPage] = useState(0);
  const [loading] = useState(false);
  const [headerTemplate, setHeaderTemplate] = useState([]);
  const [fieldTemplate, setFieldTemplate] = useState([]);
  const [columnsTemplate, setColumnTemplate] = useState('');

  const paginatedData = data.slice(currentPage * itemsPerpage, (currentPage + 1) * itemsPerpage);

  useInitialRenderEffect(() => {
    
    const makeTemplateHeader = () => {
      const {newFieldTemplate, newHeaderTemplate, newWidthCollection} = generateHeader(header, groupBy);
      setFieldTemplate(newFieldTemplate);
      setHeaderTemplate(newHeaderTemplate);
      const value = generateRowRule(newWidthCollection);
      setColumnTemplate(value);
    };
    makeTemplateHeader();
  }, []);

  useEffect(() => {
    dispatch(setCurrentCel(state.currentCel ? Object.assign(state.currentCel, editableCelOnly) : {editableCelOnly}));
  }, [itemsPerpage, currentPage, fieldTemplate, editableCelOnly, state.currentCel]);

 



  return (
    <DataGridContext.Provider value={{state, dispatch}}>
     
      <DataGridContainer  style={{maxHeight: '350px'}}>
        {loading || !fieldTemplate.length ? (
          <div className="d-flex w-100 h-100 align-items-center justify-content-center">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : (
          <div className="content-grid d-flex full-screen">
            {fixedColumn && (
              <div >
                
                {fixedColumn.accumulator && fixedColumn.accumulator.length && (
                  <>
                    {fixedColumn.accumulator.map((item) => (
                      <AccumulatorRow key={item.title}>
                        <AccumulatorCel>
                          <div style={{}}>{item.title}:</div>
                        </AccumulatorCel>
                      </AccumulatorRow>
                    ))}
                  </>
                )}
              </div>
            )}

            <div className={`editable-grid ${fixedColumn ? 'col-9 p-0 overflow-auto' : 'w-100'}`}>
              <div className="content-grid-scroll">
                <EditableGrid
                  width={`${fixedColumn ? 'max-content' : `${groupBy ? 'auto' : width}`}`}
                  accumulators={accumulators}
                  groupBy={groupBy}
                  headerTemplate={headerTemplate}
                  fieldTemplate={fieldTemplate}
                  columnsTemplate={columnsTemplate}
                  keyProp={keyProp}
                  keyValueProp={keyValueProp}
                  titleProp={titleProp}
                  dataValues={paginatedData}
                />
                {accumulators && fixedColumn && (
                  <Accumulators
                    fixed={fixedAccumulator}
                    //groupBy={groupBy}
                    groupedData={paginatedData}
                    accumulatorsConfig={accumulators}
                    //fieldHeaders={fieldTemplate.filter((_header) => !_header.subFields)}
                    columnsTemplate={columnsTemplate}
                    width={fixedColumn ? 'max-content' : width}
                  />
                )}
              </div>
            </div>
          </div>
        )}
        {accumulators && !fixedColumn && (
          <Accumulators
            //customClass="sticky"
            fixed={fixedAccumulator}
            groupBy={groupBy}
            groupedData={data}
            general
            accumulatorsConfig={accumulators}
            fieldHeaders={fieldTemplate.filter((_header) => !_header.subFields)}
            columnsTemplate={columnsTemplate}
            //width={fixedColumn ? 'max-content' : width}
          />
        )}
      </DataGridContainer>
      {(disabledPaginate === false || disabledPaginate === undefined) && (
        <PaginationFooter
          activePage={currentPage}
          itemsCountPerPage={itemsPerpage}
          totalItemsCount={data.length}
          pageRangeDisplayed={1}
          itemClass="page-item"
          linkClass="page-link"
          onChange={(paginationData) => {
            if (paginationData?.itemsPerPage) {
              window.localStorage.setItem(
                'perPageStorage',
                JSON.stringify({
                  ...(JSON.parse(window.localStorage.getItem('perPageStorage')) || {}),
                  [location.pathname]: paginationData.itemsPerPage,
                })
              );
              setItemsPerpage(paginationData.itemsPerPage);
              setCurrentPage(0); // reseta para a primeira página ao mudar o tamanho da página
            } else if (paginationData?.pageNumber) {
              setCurrentPage(paginationData.pageNumber - 1);
            }
          }}
        />
      )}
      {alertProps && <Alert type={alertProps.type} message={alertProps.message} time={alertProps.time} />}
      
    </DataGridContext.Provider>
  );
};

export default DashDataGrid;
